







































import { editFactory } from '@/main/pages';

import { NAME, TAB_NAMES } from './constants';
import { store } from './store/edit';
import ZakladniInformace from './tabs/ZakladniInformace.vue';
import TechStav1 from './tabs/TechStav1.vue';
import TechStav2 from './tabs/TechStav2.vue';
import Ostatni from './tabs/Ostatni.vue';
import Texty from './tabs/Texty.vue';

export default editFactory(NAME, store).extend({
	components: {
		ZakladniInformace,
		TechStav1,
		TechStav2,
		Ostatni,
		Texty,
	},
	data() {
		return {
			tabItems: {
				[TAB_NAMES.ZAKLADNI_INFORMACE]: { id: 'zInfo', labelKey: 'Z_Info' },
				[TAB_NAMES.TECH_STAV_1]: { id: 'ovTabTechStav', labelKey: 'OVtabTechStav' },
				[TAB_NAMES.TECH_STAV_2]: { id: 'ovTabTechStav1', labelKey: 'OVtabTechStav1' },
				[TAB_NAMES.OSTATNI]: { id: 'ostatni', labelKey: 'Ostatni' },
				[TAB_NAMES.TEXTY]: { id: 'ovTabTexty', labelKey: 'NVtabTexty' },
			},
			tabNames: TAB_NAMES,
		};
	},
});
